import { getAccessToken, getUserPrivileges, } from '@thoughtspot/session-service';
import { getIdpDomain } from '@thoughtspot/system-config-service';
export const getDefaultSamlHeaders = () => {
    return {
        accessToken: `Bearer ${getAccessToken()}`,
        xTsPrivileges: btoa(JSON.stringify(getUserPrivileges())),
        xTsIdpDomain: getIdpDomain(),
    };
};
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["SAVE"] = "SAVE";
    TranslationsKeys["ACTION"] = "Action";
    TranslationsKeys["CANCEL"] = "CANCEL";
    TranslationsKeys["SAML_HEADING"] = "saml.heading";
    TranslationsKeys["SAML_CONFIGURED_HEADING"] = "saml.configured.heading";
    TranslationsKeys["SAML_CONTENT"] = "saml.content";
    TranslationsKeys["SAML_CONFIGURE_LABEL"] = "configure.label";
    TranslationsKeys["SAML_MODAL_EDIT"] = "modal.edit";
    TranslationsKeys["SAML_REMOVE_BUTTON_TEXT"] = "removeButtonText";
    TranslationsKeys["AUTOMATICALLY_CREATE_USERS"] = "mapping.userAddedInThoughtSpot";
    TranslationsKeys["MESSAGE_API_FAILURE"] = "smtp.message.apiFailure";
    TranslationsKeys["DELETE_SUCCESS"] = "smtp.delete.success";
    TranslationsKeys["ADD_UPDATE_SUCCESS"] = "saml.successfully.updated";
    TranslationsKeys["ENABLE"] = "status.Enable";
    TranslationsKeys["DISABLE"] = "status.Disable";
    TranslationsKeys["ENABLED"] = "status.Enabled";
    TranslationsKeys["DISABLED"] = "status.Disabled";
    TranslationsKeys["INTERNAL_AUTH_CONFIGURED_HEADING"] = "internalAuth.configured.heading";
    TranslationsKeys["OK"] = "modal.ok";
    TranslationsKeys["TOAST_CHANGES_SAVED"] = "security.toastSuccess";
    TranslationsKeys["INTERNAL_AUTH_FORM_CONTENT"] = "internalAuth.form.content";
    TranslationsKeys["INTERNAL_AUTH_FORM_LABEL"] = "configComponent.title.internalAuthentication";
    TranslationsKeys["INTERNAL_AUTH_ERROR_AD_SAML_NOT_CONFIGURED"] = "error.internalAuth.adSamlNotConfigured";
    TranslationsKeys["INTERNAL_AUTH_ERROR_OIDC_SAML_NOT_CONFIGURED"] = "error.internalAuth.OidcSAMLNotConfigured";
    TranslationsKeys["INTERNEL_AUTH_CONFIG_LOAD_ERROR"] = "error.internalAuth.configNotLoaded";
    TranslationsKeys["AD_ERROR_INVALID_PORT"] = "error.ad.invalidPort";
    TranslationsKeys["AD_HEADING"] = "ad.heading";
    TranslationsKeys["AD_CONTENT"] = "ad.content";
    TranslationsKeys["AD_TEST_HEADING"] = "ad.test.modal.heading";
    TranslationsKeys["AD_TEST_CONTENT"] = "ad.test.content";
    TranslationsKeys["AD_TEST_BUTTON"] = "nas.test.title";
    TranslationsKeys["AD_TEST_USERNAME_LABEL"] = "ad.test.username";
    TranslationsKeys["AD_TEST_USERNAME_PLACEHOLDER"] = "ad.test.usernamePlaceholder";
    TranslationsKeys["AD_TEST_PASSWORD_LABEL"] = "ad.test.password";
    TranslationsKeys["AD_TEST_PASSWORD_PLACEHOLDER"] = "ad.test.passwordPlaceholder";
    TranslationsKeys["AD_SSL_CERTIFICATE_ERROR"] = "error.ad.sslCertificate";
    TranslationsKeys["AD_CERTIFICATE_ALIAS_ERROR"] = "error.ad.certificateAlias";
    TranslationsKeys["AD_USER_ADDED_IN_TS"] = "mapping.userAddedInThoughtSpot";
    TranslationsKeys["SAVE_CONFIRMATION_LOADING_MESSAGE"] = "tscli.ui.saveconfirmation.loading.message";
    TranslationsKeys["PROVISIONING_HEADER"] = "provisioning.heading.title";
    TranslationsKeys["PROVISIONING_IDP_LIST"] = "provisioning.idp.form.title";
    TranslationsKeys["PROVISIONING_BASE_URL"] = "provisioning.baseurl.title";
    TranslationsKeys["PROVISIONING_FORM_TITLE"] = "provisioning.form.title";
    TranslationsKeys["PROVISIONING_HEADING_SUBTITLE"] = "provisioning.heading.subtitle";
    TranslationsKeys["PROVISIONING_AUTH_GENERATE_WARNING"] = "generate.auth.generate.warning";
    TranslationsKeys["PROVISIONING_AUTH_GENERATE_CANCEL"] = "mfa.auth.modal.cancel";
    TranslationsKeys["PROVISIONING_AUTH_MODAL_MESSAGE"] = "scim.auth.modal.generate";
    TranslationsKeys["PROVISIONING_AUTH_LOADING_TEXT"] = "scim.auth.loading.label";
    TranslationsKeys["PROVISIONING_FETCH_ERROR"] = "scim.fetch.error";
    TranslationsKeys["PROVISIONING_GENERATE_ERROR"] = "scim.generate.error";
    TranslationsKeys["PROVISIONING_GENERATE_SUCCESS"] = "scim.generate.success.message";
    TranslationsKeys["PROVISIONING_COPIED_SUCCESS"] = "scim.copy.success.message";
    TranslationsKeys["PROVISIOINING_AUTH_TITLE"] = "scim.auth.modal.title";
    TranslationsKeys["PROVISIOINING_COPY_BUTTON"] = "provisioning.copy.button.text";
    TranslationsKeys["PROVISIOINING_GENERATE_BUTTON"] = "provisioning.generate.button.text";
    TranslationsKeys["PROVISIOINING_ACTION_TITLE"] = "provisioning.action.title";
    TranslationsKeys["SETTINGS_PROVISIONING_HEADING_SUBTITLE"] = "settings.provisioning.heading.subtitle";
    TranslationsKeys["SETTINGS_SCIM_BASEURL_INFO"] = "settings.scim.baseurl.info";
    TranslationsKeys["SETTINGS_PROVISIONING_ACTION_TITLE"] = "settings.provisioning.action.title";
    TranslationsKeys["SETTINGS_SCIM_REGENERATE_WARNING"] = "settings.scim.regenerate.warning";
    TranslationsKeys["SETTINGS_SCIM_PROVISIONING_COPY_BUTTON"] = "settings.scim.provisioning.copy.button.text";
    TranslationsKeys["SETTINGS_SCIM_BASEURL_COPIED_SUCCESS"] = "settings.scim.baseurl.copied.success";
    TranslationsKeys["SETTINGS_COPIED"] = "settings.copied";
    TranslationsKeys["SETTINGS_MODAL_TITLE"] = "settings.modal.title";
    TranslationsKeys["SETTINGS_SIDEBAR_SCIM_PROVISIONING"] = "settings.sidebar.scimProvisioning";
    TranslationsKeys["SETTINGS_SIDEBAR_LOCAL_AUTH"] = "settings.sidebar.localAuth";
    TranslationsKeys["SETTINGS_SIDEBAR_MFA_SETTINGS"] = "settings.sidebar.mfaSettings";
    TranslationsKeys["SECURITY_LEARN_MORE"] = "security.learnMore";
    TranslationsKeys["SETTINGS_SCIM_GENERATE_INFO"] = "scim.genrate.info";
    TranslationsKeys["SETTINGS_SCIM_GENERATE_TOKEN_INFO"] = "settings.scim.generate.token.info";
    TranslationsKeys["SETTINGS_SCIM_GENERATE_TOKEN_PRESENTED_INFO"] = "settings.scim.generate.token.presented.info";
    TranslationsKeys["SETTINGS_SCIM_ERROR_DEFAULT"] = "settings.scim.error.default";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_ENABLE"] = "settings.localAuth.enable";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_MFA_SETTINGS"] = "settings.localAuth.mfaSettings";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_MFA_DISABLED_WARNING"] = "settings.localAuth.mfaDisabledWarning";
    TranslationsKeys["SETTINGS_AUTH_CHANGES_SAVED"] = "settings.auth.changes.saved";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_MFA_CLUSTER_LEVEL"] = "settings.localAuth.mfaClusterLevel";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_MFA_ORG_LEVEL"] = "settings.localAuth.mfaOrgLevel";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_METHODS"] = "settings.localAuth.methods";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_PROVIDER_OKTA"] = "settings.localAuth.provider.okta";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_PROVIDER_GOOGLE"] = "settings.localAuth.provider.google";
    TranslationsKeys["SETTINGS_LOCAL_AUTH_PROVIDER_TOTP"] = "settings.localAuth.provider.totp";
})(TranslationsKeys || (TranslationsKeys = {}));
export const parseFormData = (currentFormData = []) => {
    const formData = {};
    currentFormData.forEach((i) => {
        formData[i.id] = ['true', 'false'].includes(i.value)
            ? i.value === 'true'
            : i.file || i.value;
    });
    return formData;
};
export const validatePort = (url) => {
    if (url) {
        const port = url.split(':').pop();
        if (port > 0 && port <= 65535 && port % 1 === 0) {
            return true;
        }
    }
    return false;
};
export const SAML_FORM_FIELDS = {
    SERVER_NAME: 'server_name',
    PROTOCOL: 'protocol',
    SERVER_PORT: 'server_port',
    SERVICE_NAME: 'service_name',
    RESPONSE_SKEW: 'response_skew',
    AUTOMATICALLY_CREATE_USERS: 'automatically_create_users',
    IDP_METADATA: 'idp_metadata',
};
export const SAML_DEFAULT_RESPONSE_SKEW = '3600';
//# sourceMappingURL=constants.js.map